<form [formGroup]="qualificationForm" (ngSubmit)="onSubmit()">
  <fieldset>
    <legend class="custom-legend">Caractéristiques du poste</legend>

    <div class="row">
      <div class="col-6">
        <div class="row">
          <label for="etatPoste" id="label-etat" class="label col-6 col-form-label">Etat du poste@if (this.qualificationForm.get('etatPoste')?.hasValidator(ValidatorsRef.required)) {
            *
          }</label>
          <div class="form-text mb-1">
            Sélectionnez l'état du poste.
          </div>
          <mat-form-field class="w-100">
            <mat-select formControlName="etatPoste" required>
              <mat-option value="Ouvert"> Ouvert</mat-option>
              <mat-option value="Ferme"> Fermé</mat-option>
            </mat-select>
            @if (qualificationForm.get('etatPoste')?.hasError('required') && qualificationForm.get('etatPoste')?.touched) {
              <mat-error
                >
                L'état du poste est requis.
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <div class="col-6">
        <div class="row">
          <label for="occupationPoste" id="label-occupationPoste" class="label col-6 col-form-label">Occupation du poste@if (this.qualificationForm.get('occupationPoste')?.hasValidator(ValidatorsRef.required)) {
            *
          }</label>
          <div class="form-text mb-1">
            <span>Sélectionnez l'occupation du poste.</span>
          </div>
          <mat-form-field class="w-100">
            <mat-select formControlName="occupationPoste" required>
              <mat-option value="Pourvu"> Pourvu</mat-option>
              <mat-option value="Vacant"> Vacant</mat-option>
            </mat-select>
            @if (val_ft_occupation_poste) {
              <button matSuffix mat-icon-button aria-label="Clear"
                (click)="effaceFilteOccupationPoste($event, 'occupationPoste')">
                <mat-icon>close</mat-icon>
              </button>
            }
            @if (qualificationForm.get('occupationPoste')?.hasError('required') && qualificationForm.get('occupationPoste')?.touched) {
              <mat-error
                >
                L'occupation du poste est requise.
              </mat-error>
            }
          </mat-form-field>
        </div>
      </div>
      <div class="col-6">
        <label for="categoriePoste" id="label-categoriePoste" class="label col-6 col-form-label">Catégorie du
        poste</label>
        <div class="form-text mb-1">
          <span>Sélectionnez la catégorie du poste.</span>
        </div>
        <mat-form-field class="w-100">
          <mat-select formControlName="categoriePoste" [compareWith]="compareCategories">
            @for (categorie of categoriePosteList; track categorie) {
              <mat-option [value]="categorie">
                {{ categorie.code }}
              </mat-option>
            }
          </mat-select>
          @if (val_ft_categorie_poste) {
            <button matSuffix mat-icon-button aria-label="Clear"
              (click)="effaceFilteCategoriePoste($event, 'categoriePoste')">
              <mat-icon>close</mat-icon>
            </button>
          }
          <!-- categoriePoste is never required per business rules -->
        </mat-form-field>
      </div>
      <div class="col-6">
        <div class="row">
          <mat-label id="label-detenteurPoste" class="label col-6 col-form-label">Détenteur du poste</mat-label>
          <div class="form-text mb-1">Saissisez le détenteur du poste.</div>
          @if (detenteurPosteReadOnly) {
            <mat-form-field class="w-100">
              <input #autoCompleteAgent type="text" aria-label="detenteur poste" matInput name="agent"
                [matAutocomplete]="auto" formControlName="detenteurPoste" (input)="agentFilter($event)"
                [(ngModel)]="val_ft_detenteur_poste" />
                <mat-autocomplete #auto="matAutocomplete" hideSingleSelectionIndicator requireSelection
                  [displayWith]="agentdisplayFn">
                  @for (agent of filteredAgentList; track agent) {
                    <mat-option [value]="agent"> {{ agent.nom }} {{ agent.prenom }}
                    </mat-option>
                  }
                </mat-autocomplete>
                <!-- detenteurPoste is never required per business rules -->
              </mat-form-field>
            }
            @if (!detenteurPosteReadOnly) {
              <mat-form-field class="w-100">
                <input type="text" aria-label="detenteur poste" matInput name="agent" formControlName="detenteurPoste"
                  [(ngModel)]="val_ft_detenteur_poste" />
                  @if (val_ft_detenteur_poste) {
                    <button matSuffix mat-icon-button aria-label="Clear"
                      (click)="effaceField($event, 'detenteurPoste')">
                      <mat-icon>close</mat-icon>
                    </button>
                  }
                  <!-- detenteurPoste is never required per business rules -->
                </mat-form-field>
              }
            </div>
          </div>

          <div class="col-6">
            <div class="row">
              <label for="dateRecrutement" id="label-dateRecrutement" class="label col-6 col-form-label">Date de recrutement souhaitée@if (this.qualificationForm.get('dateRecrutement')?.hasValidator(ValidatorsRef.required)) {
                *
              }</label>
              <div class="form-text mb-1">Sélectionnez ou saisissez une date au format DD/MM/YYYY.</div>
              <mat-form-field class="w-100">
                <input matInput [matDatepicker]="recruitmentDatePicker" [min]="minDateRecrutement" type="text"
                  formControlName="dateRecrutement" (dateChange)="onChangeRecrutementdate()" required />
                  <mat-datepicker-toggle matSuffix [for]="recruitmentDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #recruitmentDatePicker></mat-datepicker>
                  @if (qualificationForm.get('dateRecrutement')?.hasError('required') && qualificationForm.get('dateRecrutement')?.touched) {
                    <mat-error
                      >
                      La date de recrutement est requise.
                    </mat-error>
                  }
                  @if (qualificationForm.get('dateRecrutement')?.hasError('dateInvalide')) {
                    <mat-error>
                      La date de recrutement doit être antérieure à la date de départ.
                    </mat-error>
                  }
                  @if (qualificationForm.get('dateRecrutement')?.hasError('dateJourRecrutement')) {
                    <mat-error>
                      La date de recrutement doit être supérieure ou égale à la date du jour.
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>

            <div class="col-6">
              <label for="dateDepart" id="label-dateDepart" class="label col-6 col-form-label">Date de départ
              définitif</label>
              <div class="form-text mb-1">Sélectionnez ou saisissez une date au format DD/MM/YYYY.</div>
              <mat-form-field class="w-100">
                <input matInput [matDatepicker]="departDatePicker" [min]="minDateDepart" tyoe="text"
                  formControlName="dateDepart" (dateChange)="onDepartdate()" />
                  <mat-datepicker-toggle matSuffix [for]="departDatePicker"></mat-datepicker-toggle>
                  <mat-datepicker #departDatePicker></mat-datepicker>
                  <!-- <mat-error *ngIf="qualificationForm.get('dateDepart')?.hasError('required') && qualificationForm.get('dateDepart')?.touched">
                  La date de départ est requise.
                </mat-error> -->
                @if (qualificationForm.get('dateDepart')?.hasError('dateInvalide')) {
                  <mat-error>
                    La date de départ doit être postérieure à la date de recrutement.
                  </mat-error>
                }
                @if (qualificationForm.get('dateDepart')?.hasError('dateDepartJour')) {
                  <mat-error>
                    La date de départ doit être supérieure ou égale à la date du jour.
                  </mat-error>
                }
              </mat-form-field>
            </div>

            <div class="col-6" style="margin-top: 11px">
              <div class="row">
                <div class="checkbox-container">
                  <label id="typeRecrutementLabel">Type de recrutement souhaité@if (this.qualificationForm.validator) {
                    *
                  } :</label>
                  <div class="form-text mb-1">Choisissez le type de recrutement.</div>
                  <div class="checkbox-group">
                    <mat-checkbox formControlName="interne" color="primary" id="interne">Interne</mat-checkbox>
                    <mat-checkbox formControlName="externe" color="primary" id="externe">Externe</mat-checkbox>
                  </div>
                  @if (qualificationForm.hasError('atLeastOneRequired') && qualificationForm.touched) {
                    <mat-error>
                      Vous devez sélectionner au moins une option.
                    </mat-error>
                  }
                </div>
              </div>
            </div>

            <div class="col-6" style="margin-top: 11px">
              <div class="row">
                <label for="posteBudgete" id="label-posteBudgete">Poste budgété en {{ currentYear }}@if (this.qualificationForm.get('posteBudgete')?.hasValidator(ValidatorsRef.required)) {
                  *
                }</label>
                <div class="form-text mb-1">
                  <span>Sélectionnez (oui, non).</span>
                </div>
                <mat-form-field class="w-100">
                  <mat-select formControlName="posteBudgete" required>
                    <mat-option [value]="true">Oui</mat-option>
                    <mat-option [value]="false">Non</mat-option>
                  </mat-select>
                  @if (qualificationForm.get('posteBudgete')?.hasError('required') && qualificationForm.get('posteBudgete')?.touched) {
                    <mat-error
                      >
                      Le champ poste budgété est requis.
                    </mat-error>
                  }
                </mat-form-field>
              </div>
            </div>
          </div>
        </fieldset>

        <div class="button-group">
          <button mat-stroked-button type="button" (click)="onReset()"><mat-icon>autorenew</mat-icon>Réinitialiser</button>
          <button mat-stroked-button type="button" matStepperPrevious><mat-icon>undo</mat-icon>Précédent</button>
          <button mat-flat-button color="primary" type="submit" matStepperNext
          [disabled]="!qualificationForm.valid">Suivant</button>
        </div>
      </form>
